import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Imagine } from './components/Imagine';
import { BeforeAfter } from './components/BeforeAfter';
import { Problem } from './components/Problem';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full overflow-x-hidden bg-cream font-sans antialiased" data-id="element-0" data-mp="28tmfp53igeya">
      <MetaPixel data-id="element-1" data-mp="23vkvuhy9gblr" />
      <main className="w-full pb-24" data-id="element-2" data-mp="23w4gi6fape3h">
        <Hero data-id="element-3" data-mp="23v2s7099qv3t" />
        <Stats data-id="element-4" data-mp="23t8eo70bu59r" />
        <Imagine data-id="element-5" data-mp="3ijxoypkvdyjd" />
        <BeforeAfter data-id="element-6" data-mp="3ikh9me1wn113" />
        <Problem data-id="element-7" data-mp="3ij64oawq3n8e" />
        <Tomos data-id="element-8" data-mp="3ijpbavgxap74" />
        <Bonos data-id="element-9" data-mp="3ihuyy5jpw5en" />
        <Offer data-id="element-10" data-mp="3mlj8uuvtnd32" />
        <Guarantee data-id="element-11" data-mp="3ml12v6jcxkhy" />
        <Testimonials data-id="element-12" data-mp="3mkhnnxl3da7m" />
        <About data-id="element-13" data-mp="3mjq27fl7ksv2" />
        <FAQ data-id="element-14" data-mp="3mj6ibtbzzuee" />
        <FinalCTA data-id="element-15" data-mp="3rc9ca2kot5v4" />
      </main>
      <PurchasePopup data-id="element-16" data-mp="3rbzpsoyupgu6" />
      <FloatingCTA data-id="element-17" data-mp="3rcsyvwla8ifh" />
    </div>;
}